import React, { useState } from 'react';
import Background from "../../../assets/images/background/banner.jpg";
import { Link } from 'react-router-dom';


import Arrow from "../../../assets/images/Services/right-arrow.png";
import { FaCheckCircle } from "react-icons/fa";


import img1 from "../../../assets/images/Product/Odoo/image12.jpg";
import img2 from "../../../assets/images/Product/Odoo/image11.jpg";
import img3 from "../../../assets/images/Product/Odoo/image13.jpg";
import img4 from "../../../assets/images/Product/Odoo/image4.png";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import SEO from '../../seo';


export default function Odoo1() {
    const [openImageIndex, setOpenImageIndex] = useState(null);

    const images = [img1, img2, img3, img4];

     const pageKeywords = [
        "react website",
        "static pages",
        "web development",
        "SEO services"
    ];
    return (
        <div>
      <SEO
                title="Odoo Services"
                description="At HWPL! we recognize that privacy is important. This Privacy Policy applies to all products and services provided by us. Collection Of Information Disclaimer: Please read and edit the Privacy Policy given below as per your /website’s requirement. Don’t use or apply these as is basis on your website. We collect various information when you [&hellip;]"
                canonical="https://www.hwplindia.com/products/oddo-services/"
                ogImage="https://www.hwplindia.com/wp-content/uploads/2024/01/erp-crm-development-company-banner-img.png"
                keywords={pageKeywords}
            />
            <section
                className="page-title"
                style={{ backgroundImage: `url(${Background})` }}
            >
                <div className="auto-container">
                    <h2>Odoo Services</h2>
                    <ul className="bread-crumb clearfix">
                        <li>
                            <Link to="/">Home</Link>
                        </li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li>
                            <Link to="/products">Products</Link>
                        </li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li>Odoo Services</li>
                    </ul>
                </div>
            </section>
            <section className="branding-section1">
                <div className="at-container">

                    {/* Content Section */}
                    <div className="branding-content">
                        {/* CTA */}
                        <section className="cta-section attendance-h3">
                            <h3 className=''>“Odoo Licensing & Customization Services”</h3>
                            <p>
                                At Horizon Webinfo Pvt. Ltd. we empower businesses to streamline operations and scale efficiently with tailored Odoo ERP solutions. As an official Odoo development partner, we specialize in delivering end-to-end ERP services — from licensing and customization to implementation and long-term support.
                            </p>
                            <h3 className='cta-section-business-process it-consult attendance-consult'>Why Odoo for Your Business?
                            </h3>
                        </section>


                        {/* Sections */}
                        <section className='it-consult simple-section'>
                            <section className="branding-item">
                                <h4><img src={Arrow} />
                                    A Complete ERP Designed for Flexibility</h4>
                                <p>
                                    Odoo offers a suite of powerful business applications that can be fully customized to match your unique workflows. From sales and accounts to manufacturing and HR, we configure Odoo to function exactly the way your business operates.
                                </p>
                            </section>

                            <section className="branding-item">
                                <h4><img src={Arrow} />
                                    Seamless Integration & Automation</h4>
                                <p>
                                    With customizable modules and third-party integrations, Odoo simplifies complex processes and brings every department onto a single, unified platform — improving communication and overall efficiency.

                                </p>
                            </section>

                            {/* Our Expertise in Attendance */}
                            <section className="cta-section">
                                <h3 className='cta-section-business-process attendance-expert'>Our Expertise in Odoo ERP Services
                                </h3>
                            </section>
                            <section className='simple-section attaaa'>

                                <section className="attendance-li">
                                    <h4>
                                        Odoo Licensing Support</h4>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Assistance in selecting the right license</li></p>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Cost optimization & deployment guidance</li></p>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Support for Enterprise & Community editions</li></p>
                                </section>

                                <section className="attendance-li">
                                    <h4>
                                        Customization & Module Development</h4>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Tailor-made workflows for your business</li></p>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Enhancements to existing modules</li></p>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Development of completely new modules</li></p>
                                </section>

                                <section className="attendance-li">
                                    <h4>
                                        Migration & Upgrade Services
                                    </h4>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Version upgrades without data loss</li></p>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Smooth migration from legacy systems</li></p>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Improved performance & security</li></p>
                                </section>

                                <section className="attendance-li">
                                    <h4>
                                        Third-Party API Integrations
                                    </h4>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Payment gateways</li></p>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> E-commerce platforms</li></p>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> CRMs, ERPs & custom applications
                                    </li></p>
                                </section>

                                <section className="attendance-li">
                                    <h4>
                                        Dedicated Odoo Developer Support
                                    </h4>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Hire experienced Odoo developers</li></p>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Ongoing maintenance & issue resolution</li></p>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Flexible engagement models
                                    </li></p>
                                </section>

                                <section className="attendance-li">
                                    <h4>
                                        Implementation & Training

                                    </h4>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> End-to-end deployment</li></p>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> User training & documentation</li></p>
                                    <p><li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i> Change management support

                                    </li></p>
                                </section>
                            </section>

                            <div className='image-swip'>
                                <Swiper
                                    modules={[Navigation, Pagination, Autoplay]}
                                    slidesPerView={3}          // show 2 images at a time
                                    spaceBetween={30}
                                    slidesPerGroup={1}         // slide one by one
                                    navigation={false}
                                    pagination={{ clickable: true, dynamicBullets: false }}
                                    autoplay={{
                                        delay: 2500,
                                        disableOnInteraction: false,
                                    }}
                                    loop={true}
                                                breakpoints={{
                                        // Mobile
                                        0: {
                                            slidesPerView: 1,
                                        },

                                        // Small devices (landscape phones)
                                        576: {
                                            slidesPerView: 2,
                                        },

                                        // Tablets
                                        1015: {
                                            slidesPerView: 3,
                                        },

                                        // Desktop
                                        1330: {
                                            slidesPerView: 3,
                                        },
                                    }}
                                    className="branding-swiper lead-swiper"
                                >

                                    <SwiperSlide onClick={() => setOpenImageIndex(0)}>
                                        <img src={img1} className="attendance-img lead" />
                                    </SwiperSlide>

                                    <SwiperSlide onClick={() => setOpenImageIndex(1)}>
                                        <img src={img2} className="attendance-img lead" />
                                    </SwiperSlide>

                                    <SwiperSlide onClick={() => setOpenImageIndex(2)}>
                                        <img src={img3} className="attendance-img lead" />
                                    </SwiperSlide>

                                    <SwiperSlide onClick={() => setOpenImageIndex(3)}>
                                        <img src={img4} className="attendance-img lead" />
                                    </SwiperSlide>

                                </Swiper>
                                {openImageIndex !== null && (
                                    <div className="image-popup">

                                        <div className="close-btn" onClick={() => setOpenImageIndex(null)}>
                                            ✕
                                        </div>

                                        <div className="popup-img-wrapper">

                                            <button
                                                className="popup-swiper-arrow left"
                                                onClick={() =>
                                                    setOpenImageIndex(
                                                        (openImageIndex - 1 + images.length) % images.length
                                                    )
                                                }
                                            >
                                                ❮
                                            </button>

                                            <img
                                                src={images[openImageIndex]}
                                                alt="preview"
                                                className="popup-big-img"
                                            />

                                            <button
                                                className="popup-swiper-arrow right"
                                                onClick={() =>
                                                    setOpenImageIndex((openImageIndex + 1) % images.length)
                                                }
                                            >
                                                ❯
                                            </button>

                                        </div>

                                    </div>
                                )}

                            </div>

                            {/* Why This Helps Your Business */}

                            <section className="cta-section simple-section1">
                                <h3 className='cta-section-business-process attendance-expert why-lead'>Why This Helps Your Business</h3>
                            </section>

                            <section className="simple-section">
                                <div className="item">
                                    <div className="num"><img src={Arrow} /></div>
                                    <div className="content">
                                        <h4>Streamline Every Department</h4>
                                        <p>Centralize operations from sales to finance, HR, inventory, manufacturing, and more — all on one unified platform.
                                        </p>
                                    </div>
                                </div>

                                <div className="item">
                                    <div className="num"><img src={Arrow} /></div>
                                    <div className="content">
                                        <h4> Customize Odoo to Match Your Workflow

                                        </h4>
                                        <p>We tailor the ERP to your exact business processes so your team works faster and more efficiently.
                                        </p>
                                    </div>
                                </div>

                                <div className="item">
                                    <div className="num"><img src={Arrow} /></div>
                                    <div className="content">
                                        <h4>Reduce Operational Costs</h4>
                                        <p>Automation eliminates repetitive tasks, reduces manpower dependency, and improves overall profitability.
                                        </p>
                                    </div>
                                </div>

                                <div className="item">
                                    <div className="num"><img src={Arrow} /></div>
                                    <div className="content">
                                        <h4> Scale Your Business Effortlessly
                                        </h4>
                                        <p>As your company grows, Odoo grows with you — add modules or modify workflows anytime.
                                        </p>
                                    </div>
                                </div>

                                <div className="item">
                                    <div className="num"><img src={Arrow} /></div>
                                    <div className="content">
                                        <h4>Ensure Smooth Implementation & Reliable Support
                                        </h4>
                                        <p>With our expertise and long-term support, your ERP runs seamlessly with minimal downtime.
                                        </p>
                                    </div>
                                </div>
                            </section>

                            {/* Why Choose Us */}
                            <section className="why-choose attendance-choose">
                                <h3>Who Is This Ideal For?</h3>
                                <ul>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        SMEs</li>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Manufacturing Units</li>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Service Companies</li>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Trading Businesses
                                    </li>
                                </ul>
                            </section>

                            {/* CTA */}
                            <section className="cta-section attendance-p">
                                <h3>Collaborate with Us</h3>
                                <p>
                                    At Horizon Webinfo Pvt. Ltd. we bring 10+ years of software development experience and deep ERP expertise to deliver high-quality Odoo solutions. From customization to deployment, we ensure your ERP becomes a powerful growth engine for your organization.

                                </p>
                                <Link to="/get-a-quote" className="quote-btn1-brand">
                                    <span><i aria-hidden="true" class="fas fa-external-link-alt"></i> GET A QUOTE</span>
                                </Link>
                            </section>
                        </section>
                    </div>
                </div>
            </section>
        </div>
    );
}